import styles from "./YpOrder.module.scss";
import { useEffect, useRef, useState } from "react";

import TitleUpdater from "../../../components/shared/title/TitleUpdater";
import SelectComponent from "../../../components/shared/select/SelectComponent";
import InputComponent from "../../../components/shared/input/InputComponent";
import MainButton from "../../../components/shared/button/MainButton";
import { YpOrderService } from "../../../services/ypOrder.service";
import { BankCardsServices } from "../../../services/bankCards.service";
import {
  ApiPaginationResponse,
  ypBranch,
  ypData,
  ypOrder,
  BankCardType,
  DeliveryPriceResponse,
  OrderPackagesDataType,
} from "../../../interface/site.interface";
import OrderRow from "../../../components/pages/courier/OrderRow";
import { CourierServices } from "../../../services/courier.service";
import Spinner from "../../../components/shared/spinner/Spinner";
import PackagesModal from "../../../components/pages/admin-panels/courier/PackagesModal";
import Card from "../../../components/pages/card/Card";
import { toast } from "react-toastify";
import ArrowImage from "../../../assets/images/pages/login/CaretLeft.svg";
import CalendarImg from "../../../assets/images/packages/CalendarDots.svg";
import PhoneInputComponent from "../../../components/shared/input-phone-component/PhoneInputComponent";
import { useSite } from "../../../context/TranslationContext";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchTranslation } from "../../../redux/Slices/translationDataSlice";
import CardSelectModal from "../../../components/shared/card-select-modal/CardSelectModal";
import PaymentStatusModal from "../../../components/shared/payment-status-modal/PaymentStatusModal";
import PaymentMethodModal from "../../../components/shared/payment-method-modal/PaymentMethodModal";
import NoCardsModal from "../../../components/shared/no-cards-modal/NoCardsModal";
import { useServiceDebt } from "../../../hooks/useServiceDebt";
import ServiceDebtOverlay from "../../../components/shared/service-debt-overlay/ServiceDebtOverlay";

const Courier: React.FC = () => {
  const { serviceDebt, orderDebt } = useServiceDebt();
  const [formValues, setFormValues] = useState({
    phone: "",
    address: "",
    location_note: "",
    date: "",
  });

  const [azerpoctRegions, setAzerpoctRegions] = useState<ypData[]>(
    []
  );
  const dispatch = useDispatch<AppDispatch>();

  const { data } = useSelector((state: RootState) => state.translationData);
  const [azerpoctRegionsIndx, setAzerpoctRegionsIndx] = useState<string>("");
  const [poctIndex, setPoctIndex] = useState<ypBranch[]>([]);
  const [selectedPoctIndexId, setSelectedPoctIndexId] = useState<string>("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedPackages, setSelectedPackages] = useState<number[]>([]);
  const [deliveryDate, setDeliveryDate] = useState("");
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [azerpostOrder, setAzerpostOrder] = useState<ypOrder[]>([]);
  const [packages, setPackages] = useState<OrderPackagesDataType[]>([]);
  const [orderHistoryLoading, setOrderHistoryLoading] = useState(true);
  const [responseCalculate, setResponseCalculate] =
    useState<DeliveryPriceResponse | null>(null);
  const [paginationData, setPaginationData] =
    useState<ApiPaginationResponse<ypOrder> | null>(null);
  const [minDate, setMinDate] = useState<string>("");
  const [maxDate, setMaxDate] = useState<string>("");
  const [selectedPackageObjects, setSelectedPackageObjects] = useState<
    OrderPackagesDataType[]
  >([]);
  const [phoneCode, setPhoneCode] = useState("50");
  const [showAllPackages, setShowAllPackages] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [cards, setCards] = useState<BankCardType[]>([]);
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);
  const [isPaymentStatusOpen, setIsPaymentStatusOpen] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isCardPaymentLoading, setIsCardPaymentLoading] = useState(false);
  const [pendingPayload, setPendingPayload] = useState<any>(null);
  const [isPaymentMethodModalOpen, setIsPaymentMethodModalOpen] = useState(false);
  const [paymentErrorMessage, setPaymentErrorMessage] = useState("");
  const [isNoCardsModalOpen, setIsNoCardsModalOpen] = useState(false);
  const language = useSelector((state: RootState) => state.language.language);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const citiesRes = await YpOrderService.getYpCitites();
        
        const citiesData = citiesRes?.data?.original || citiesRes?.data || citiesRes;
        
        if (Array.isArray(citiesData)) {
          setAzerpoctRegions(citiesData);
        } else if (citiesData && Array.isArray(citiesData.data)) {
          setAzerpoctRegions(citiesData.data);
        } else {
          console.error('Unexpected cities data structure:', citiesData);
          setAzerpoctRegions([]);
        }
        
        const ordersRes = await YpOrderService.getYptOrders();

        if (ordersRes.data?.data && Array.isArray(ordersRes.data.data)) {
          setAzerpostOrder(ordersRes.data.data);
          setPaginationData(ordersRes.data);
        } else if (Array.isArray(ordersRes.data)) {
          setAzerpostOrder(ordersRes.data);
        } else {
          setAzerpostOrder([]);
        }
        
        const packagesRes = await CourierServices.getAllPackages();
        setPackages(Array.isArray(packagesRes?.data?.original) ? packagesRes.data.original : []);
        
      } catch (error) {
        console.error('Fetch error:', error);
        setAzerpostOrder([]);
        setAzerpoctRegions([]);
      } finally {
        setOrderHistoryLoading(false);
      }
    };

    fetchData();
  }, [language]);

  useEffect(() => {
    if (azerpoctRegionsIndx) {
      YpOrderService.getYpBranches(azerpoctRegionsIndx)
        .then((res) => {
          const branchesData = res?.data?.original || res?.data || res;

          if (Array.isArray(branchesData)) {
            setPoctIndex(branchesData);
          } else {
            setPoctIndex([]);
          }
          
          setSelectedPoctIndexId("");
        })
        .catch((error) => {
          console.error('Branches error:', error);
          setPoctIndex([]);
        });
    } else {
      setPoctIndex([]);
      setSelectedPoctIndexId("");
    }
  }, [azerpoctRegionsIndx]);

  useEffect(() => {
    if (selectedPackages.length > 0 && selectedPoctIndexId) {
      handlePostOnChange();
    } else {
      setResponseCalculate(null);
    }
  }, [selectedPackages, selectedPoctIndexId]);

  const handlePackageClick = () => {
    setIsModalVisible(true);
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handlePostOnChange = async () => {
    if (selectedPackages.length === 0 || !selectedPoctIndexId) {
      setResponseCalculate(null);
      return;
    }

    const payload = {
      package_ids: selectedPackages,
      branch_id: parseInt(selectedPoctIndexId),
    };

    try {
      const response = await YpOrderService.Post_calculatedelivery(payload);
      setResponseCalculate(response.data);
    } catch (error) {
      console.error('Calculate error:', error);
      setResponseCalculate(null);
    }
  };

const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  const validationErrors: { [key: string]: string } = {};

  if (!azerpoctRegionsIndx) {
    validationErrors.city_id = "Şəhər seçin";
  }
  if (!selectedPoctIndexId) {
    validationErrors.post_zip = "Poçt filialını seçin";
  }
  if (!formValues.phone || formValues.phone.trim().length < 7) {
    validationErrors.phone = data?.required_field || "Telefon nömrəsini daxil edin";
  }
  if (selectedPackages.length === 0) {
    validationErrors.packages_list = data?.select_package || "Bağlama seçin";
  }

  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  // responseCalculate yoxdursa gozle
  if (!responseCalculate) {
    toast.error('Qiymət hesablanır, bir az gözləyin');
    return;
  }

  // Total mebleği hesabla
  const totalAmount = (responseCalculate.delivery_price ?? 0) + (responseCalculate.courier_price ?? 0);

  setIsSubmitting(true);

  const payload = {
    package_ids: selectedPackages,
    branch_id: parseInt(selectedPoctIndexId),
    phone_prefix: phoneCode,
    phone: formValues.phone,
  };

  // Eger total 0-dirsa birbasa sifaris yarat (kart olmadan)
  if (totalAmount === 0) {
    try {
      const response = await YpOrderService.PostYpOrder(payload);
      const responseData = response.data;

      if (responseData?.case === "success") {
        setPaymentErrorMessage("");
        setPaymentSuccess(true);
        setIsPaymentStatusOpen(true);
        setErrors({});

        setSelectedPackages([]);
        setSelectedPackageObjects([]);
        setAzerpoctRegionsIndx("");
        setSelectedPoctIndexId("");
        setPoctIndex([]);
        setResponseCalculate(null);
      } else {
        let rawErr = responseData?.content;
        if (typeof rawErr === "string") {
          try { const p = JSON.parse(rawErr); rawErr = p?.content || rawErr; } catch {}
        }
        setPaymentErrorMessage(typeof rawErr === "string" ? rawErr : "");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      }
    } catch (error: any) {
      console.error("Sifaris xetasi:", error);
      let backendError = error?.content;
      if (typeof backendError === "string") {
        try { const p = JSON.parse(backendError); backendError = p?.content || backendError; } catch {}
      }
      setPaymentErrorMessage(typeof backendError === "string" ? backendError : "");
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    } finally {
      setIsSubmitting(false);
    }
    return;
  }

  // Odenis metodu secimi (mebleg > 0 oldugda)
  setPendingPayload(payload);
  setIsPaymentMethodModalOpen(true);
  setIsSubmitting(false);
};

const handleSelectBalancePayment = async () => {
  if (!pendingPayload) return;
  setIsSubmitting(true);
  try {
    const response = await YpOrderService.PostYpOrder({ ...pendingPayload, payment_provider: "balance" });
    const responseData = response?.data;
    setIsPaymentMethodModalOpen(false);
    if (responseData?.case === "success") {
      setPaymentErrorMessage("");
      setPaymentSuccess(true);
      setIsPaymentStatusOpen(true);
      setErrors({});
      setSelectedPackages([]);
      setSelectedPackageObjects([]);
      setAzerpoctRegionsIndx("");
      setSelectedPoctIndexId("");
      setPoctIndex([]);
      setResponseCalculate(null);
    } else {
      let rawErr = responseData?.content;
      if (typeof rawErr === "string") { try { const p = JSON.parse(rawErr); rawErr = p?.content || rawErr; } catch {} }
      setPaymentErrorMessage(typeof rawErr === "string" ? rawErr : "");
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    }
  } catch (error: any) {
    setIsPaymentMethodModalOpen(false);
    let backendError = error?.content;
    if (typeof backendError === "string") { try { const p = JSON.parse(backendError); backendError = p?.content || backendError; } catch {} }
    if (backendError && typeof backendError === "object") { setErrors(backendError); }
    else { setPaymentErrorMessage(typeof backendError === "string" ? backendError : ""); setPaymentSuccess(false); setIsPaymentStatusOpen(true); }
  } finally {
    setIsSubmitting(false);
  }
};

const handleSelectCardPayment = async () => {
  setIsPaymentMethodModalOpen(false);
  try {
    const response = await BankCardsServices.getBankCards();
    const cardsList = response.data?.data || [];

    if (cardsList.length === 0) {
      setIsNoCardsModalOpen(true);
      return;
    }

    setCards(cardsList);
    setIsCardModalOpen(true);
  } catch (error) {
    console.error("Kartlar yuklenirken xeta:", error);
    setIsNoCardsModalOpen(true);
  }
};

const handleSelectDirectPayment = async () => {
  setIsPaymentMethodModalOpen(false);
  if (!pendingPayload) return;
  setIsSubmitting(true);
  try {
    const response = await YpOrderService.PostYpOrder({
      ...pendingPayload,
      payment_provider: "yigim_direct",
    });
    const responseData = response?.data;
    if (responseData?.case === "success" && responseData?.url) {
      window.location.href = responseData.url;
    } else {
      let rawErr = responseData?.content;
      if (typeof rawErr === "string") { try { const p = JSON.parse(rawErr); rawErr = p?.content || rawErr; } catch {} }
      setPaymentErrorMessage(typeof rawErr === "string" ? rawErr : "");
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    }
  } catch (error: any) {
    let backendError = error?.content;
    if (typeof backendError === "string") { try { const p = JSON.parse(backendError); backendError = p?.content || backendError; } catch {} }
    setPaymentErrorMessage(typeof backendError === "string" ? backendError : "");
    setPaymentSuccess(false);
    setIsPaymentStatusOpen(true);
  } finally {
    setIsSubmitting(false);
  }
};

const handleSelectPashaPayment = async () => {
  setIsPaymentMethodModalOpen(false);
  if (!pendingPayload) return;

  setIsSubmitting(true);
  try {
    const payloadWithPasha = {
      ...pendingPayload,
      payment_provider: "pasha",
    };

    const response = await YpOrderService.PostYpOrder(payloadWithPasha);
    const responseData = response.data;

    if (
      responseData?.case === "success" &&
      responseData?.pay === true &&
      responseData?.content
    ) {
      window.location.href = responseData.content;
    } else if (responseData?.case === "success") {
      setPaymentErrorMessage("");
      setPaymentSuccess(true);
      setIsPaymentStatusOpen(true);
      setErrors({});

      setSelectedPackages([]);
      setSelectedPackageObjects([]);
      setAzerpoctRegionsIndx("");
      setSelectedPoctIndexId("");
      setPoctIndex([]);
      setResponseCalculate(null);
    } else {
      let rawErr = responseData?.content;
      if (typeof rawErr === "string") {
        try { const p = JSON.parse(rawErr); rawErr = p?.content || rawErr; } catch {}
      }
      setPaymentErrorMessage(typeof rawErr === "string" ? rawErr : "");
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    }
  } catch (error: any) {
    let backendError = error?.content;
    if (typeof backendError === "string") {
      try { const p = JSON.parse(backendError); backendError = p?.content || backendError; } catch {}
    }
    if (backendError && typeof backendError === "object") {
      setErrors(backendError);
    } else if (typeof backendError === "string") {
      setPaymentErrorMessage(backendError);
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    } else {
      setPaymentErrorMessage("");
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    }
  } finally {
    setIsSubmitting(false);
  }
};

const handleCardSelect = async (cardId: number) => {
  if (!pendingPayload) return;

  setIsCardPaymentLoading(true);
  try {
    const payloadWithCard = {
      ...pendingPayload,
      card_id: cardId,
      payment_provider: "card",
    };

    const response = await YpOrderService.PostYpOrder(payloadWithCard);
    const responseData = response.data;

    if (responseData?.case === "success") {
      setPaymentErrorMessage("");
      setPaymentSuccess(true);
      setIsPaymentStatusOpen(true);
      setErrors({});

      setSelectedPackages([]);
      setSelectedPackageObjects([]);
      setAzerpoctRegionsIndx("");
      setSelectedPoctIndexId("");
      setPoctIndex([]);
      setResponseCalculate(null);
    } else {
      let rawErr = responseData?.content;
      if (typeof rawErr === "string") {
        try { const p = JSON.parse(rawErr); rawErr = p?.content || rawErr; } catch {}
      }
      setPaymentErrorMessage(typeof rawErr === "string" ? rawErr : "");
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    }
  } catch (error: any) {
    console.error("Kart odenisi xetasi:", error);
    let backendError = error?.content;
    if (typeof backendError === "string") {
      try { const p = JSON.parse(backendError); backendError = p?.content || backendError; } catch {}
    }
    if (backendError && typeof backendError === "object") {
      setErrors(backendError);
    } else if (typeof backendError === "string") {
      setPaymentErrorMessage(backendError);
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    } else {
      setPaymentErrorMessage("");
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    }
  } finally {
    setIsCardPaymentLoading(false);
    setIsCardModalOpen(false);
  }
};

const handlePaymentRedirect = () => {
  setIsPaymentStatusOpen(false);
  if (paymentSuccess) {
    window.location.reload();
  }
};

// Helper - Refresh orders
const refreshOrders = async () => {
  try {
    const ordersRes = await YpOrderService.getYptOrders();
    
    if (ordersRes.data?.data && Array.isArray(ordersRes.data.data)) {
      setAzerpostOrder(ordersRes.data.data);
      setPaginationData(ordersRes.data);
    } else if (Array.isArray(ordersRes.data)) {
      setAzerpostOrder(ordersRes.data);
    }
  } catch (error) {
    console.error('Refresh orders error:', error);
  }
};

  const handlePageChange = async (urlOrPage: string | number) => {
    setOrderHistoryLoading(true);
    try {
      const url = typeof urlOrPage === "string" ? urlOrPage : undefined;
      const page = typeof urlOrPage === "number" ? urlOrPage : undefined;
      const response = await YpOrderService.getYptOrders(url, undefined, page);

      if (response.data?.data && Array.isArray(response.data.data)) {
        setAzerpostOrder(response.data.data);
        setPaginationData(response.data);
      } else if (Array.isArray(response.data)) {
        setAzerpostOrder(response.data);
      } else {
        setAzerpostOrder([]);
      }
    } catch (error) {
      console.error('Pagination error:', error);
      setAzerpostOrder([]);
      toast.error(data?.error_occurred);
    } finally {
      setOrderHistoryLoading(false);
    }
  };
  useEffect(() => {}, [paginationData]);
  useEffect(() => {
    CourierServices.get_courierSetting().then((res) => {
      const setting = res.data.original;
      if (setting) {
        const formatDate = (dateString: string) => {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          const day = date.getDate().toString().padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        const min = formatDate(setting.min_date);
        const max = formatDate(setting.max_date);

        setMinDate(min);
        setMaxDate(max);
      }
    });
  }, []);
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);
  useEffect(() => {
    if (selectedPackages.length > 0) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.packages_list;
        return newErrors;
      });
    }
  }, [selectedPackages]);

  return (
    <>
      {(serviceDebt.hasDebt || orderDebt.hasDebt) && <ServiceDebtOverlay serviceDebt={serviceDebt} orderDebt={orderDebt} />}
      <TitleUpdater
        title={
          data?.colibri && data?.auth_left_sidebar_yp_order
            ? `${data?.colibri} | ${data?.auth_left_sidebar_yp_order}`
            : "Colibri"
        }
      />
      <div className={styles.contentWrapper}>
        <form id={styles.purchase} onSubmit={handleSubmit}>
          <div className={styles.row}>
            <SelectComponent
              label={data?.auth_azerpost_city}
              name="city"
              placeholder={data?.auth_courier_select}
              options={
                azerpoctRegions.map((item) => ({
                  label: String(item.title || `City ${item.id}`),
                  value: String(item.yp_city_id || item.id),
                }))
              }
              value={azerpoctRegionsIndx}
              onChange={(selectedValue) => {
                setAzerpoctRegionsIndx(String(selectedValue));
                setErrors((prevErrors) => {
                  const newErrors = { ...prevErrors };
                  delete newErrors.city_id;
                  return newErrors;
                });
              }}
              error={errors.city_id}
            />

            <SelectComponent
              label={data?.yp_branches}
              name="poct_indeksi"
              placeholder={data?.auth_courier_select}
              options={[
                ...poctIndex.map((item) => ({
                  label: String(`${item.name}  (${item.address})`),
                  value: String(item.id),
                })),
              ]}
              value={selectedPoctIndexId}
              onChange={(selectedValue) => {
                setSelectedPoctIndexId(String(selectedValue));
                setErrors((prevErrors) => {
                  const newErrors = { ...prevErrors };
                  delete newErrors.post_zip;
                  return newErrors;
                });
              }}
              disabled={!azerpoctRegionsIndx}
              error={errors.post_zip}
            />
          </div>

          <div className={styles.row}>
            <div
              onClick={() => { if (azerpoctRegionsIndx) handlePackageClick(); }}
              style={{ flex: 1, cursor: "pointer" }}
            >
              <SelectComponent
                label={data?.auth_azerpost_package}
                name="purchase"
                placeholder={data?.auth_courier_select}
                options={[
                  {
                    label: selectedPackages.length > 0
                      ? `${selectedPackages.length} bağlama seçildi`
                      : `${data?.select_package}`,
                    value: "custom",
                  },
                ]}
                value="custom"
                onChange={() => {
                  setErrors((prev) => { const e = { ...prev }; delete e.packages_list; return e; });
                }}
                error={errors.packages_list}
                disabled={!azerpoctRegionsIndx}
                selectedPackagesCount={selectedPackages.length}
              />
            </div>
          </div>

          <div className={`${styles.row} ${styles.phone_row}`}>
            <PhoneInputComponent
              label={data?.auth_courier_mobile_number}
              id="phone"
              name="phone"
              placeholder="0000000"
              value={""}
              onChange={(e) =>
                setFormValues((prevValues) => ({
                  ...prevValues,
                  phone: e.target.value,
                }))
              }
              onCodeChange={(code) => setPhoneCode(code)}
              error={errors.phone}
              combinePrefixWithNumber={false}
            />
          </div>
        
          <div className={styles.form_bottom}>
            <div className={styles.purchase_details}>
              <p className={styles.purchase_delivery_cost}>
                {data?.auth_azerpost_foreign_delivery}
                <span>
                  {(responseCalculate?.delivery_price ?? 0).toFixed(2)}
                  AZN
                </span>
              </p>

              <p className={styles.purchase_courier_cost}>
                {data?.yp_price}
                <span>
                  {(responseCalculate?.courier_price ?? 0).toFixed(2)}
                  AZN
                </span>
              </p>

              <p className={styles.purchase_total_cost}>
                {data?.auth_azerpost_total_amount}
                <span>
                  {(
                    (responseCalculate?.delivery_price ?? 0) +
                    (responseCalculate?.courier_price ?? 0)
                  ).toFixed(2)}{" "}
                  AZN
                </span>
              </p>
            </div>
            <MainButton
              text={data?.auth_azerpost_confirm}
              type="button"
              onClick={handleSubmit}
              className={styles.form_submitBtn}
              disabled={isSubmitting}
            />
          </div>
        </form>
        <div id={styles.order_list}>
          <div className={styles.pagination_part}>
            <p className={styles.pagination_title}>
              {data?.auth_azerpost_order_history}
            </p>
            {!(paginationData?.current_page === 1 && paginationData?.next_page_url === null) &&
              paginationData && (
                <div className={styles.pagination}>
                  <img
                    src={ArrowImage}
                    className={`${styles.pagination_arrow_left} ${!paginationData.prev_page_url ? styles.disabled : ""}`}
                    alt="Prev"
                    onClick={() => { if (paginationData.prev_page_url) handlePageChange(paginationData.prev_page_url); }}
                  />
                  {[...Array(paginationData.last_page)].map((_, index) => {
                    const page = index + 1;
                    return (
                      <p
                        key={page}
                        className={`${styles.pagination_count} ${paginationData.current_page === page ? styles.active : ""}`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </p>
                    );
                  })}
                  <img
                    src={ArrowImage}
                    className={`${styles.pagination_arrow_right} ${!paginationData.next_page_url ? styles.disabled : ""}`}
                    alt="Next"
                    onClick={() => { if (paginationData.next_page_url) handlePageChange(paginationData.next_page_url); }}
                  />
                </div>
              )}
          </div>
          {orderHistoryLoading ? (
            <div className={styles.loadingWrapper}>
              <Spinner size="large" />
            </div>
          ) : azerpostOrder.length === 0 ? (
            <div className={styles.empty}>
              {data?.auth_common_order_history_empty}
            </div>
          ) : (
            <table className={styles.order_history_list}>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>{data?.yp_branches || 'Filial'}</th>
                  <th>{data?.address || 'Ünvan'}</th>
                  <th>{data?.working_hours_yp || 'İş saatları'}</th>
                  <th>{data?.phone || 'Telefon'}</th>
                  <th>{data?.weight || 'Çəki'}</th>
                  <th>{data?.auth_azerpost_total_amount || 'Məbləğ'}</th>
                  <th>{data?.auth_azerpost_date}</th>
                  <th>{data?.status || 'Status'}</th>
                </tr>
              </thead>
              <tbody>
                {azerpostOrder?.map((order) => (
                  <tr key={order.id}>
                    <td>{order.id}</td>
                    <td>{order.branchName}</td>
                    <td>{order.address}</td>
                    <td>{order.work_hours}</td>
                    <td>{order.phone1}</td>
                    <td>{order.weight ?? '-'}</td>
                    <td>{order.amount ? `${order.amount} AZN` : '-'}</td>
                    <td>{order.order_date}</td>
                    <td>
                      <span className={`${styles.status}`}>
                        {order.status_name}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          <div className={styles.courier_card}>
            {azerpostOrder?.map((order, index) => (
              <Card key={index} {...order} YpOrder={true} order_weight={order.weight ?? undefined} />
            ))}
          </div>
        </div>
        {isModalVisible && (
          <PackagesModal
            visible={isModalVisible}
            onClose={() => setIsModalVisible(false)}
            packages={packages || []}
            selectedPackages={selectedPackages}
            setSelectedPackages={setSelectedPackages}
            handlePostOnChange={handlePostOnChange}
            setSelectedPackageObjects={setSelectedPackageObjects}
            showAllPackages={showAllPackages}
            setShowAllPackages={setShowAllPackages}
          />
        )}

        <PaymentMethodModal
          isOpen={isPaymentMethodModalOpen}
          onClose={() => setIsPaymentMethodModalOpen(false)}
          onSelectCard={handleSelectCardPayment}
          // onSelectPasha={handleSelectPashaPayment}
          onSelectBalance={handleSelectBalancePayment}
          onSelectDirectPay={handleSelectDirectPayment}
          amount={`${(
            (responseCalculate?.delivery_price ?? 0) +
            (responseCalculate?.courier_price ?? 0)
          ).toFixed(2)} AZN`}
          translationData={data}
          isLoading={isSubmitting}
        />

        <CardSelectModal
          isOpen={isCardModalOpen}
          onClose={() => setIsCardModalOpen(false)}
          onSelectCard={handleCardSelect}
          cards={cards}
          isLoading={isCardPaymentLoading}
          amount={`${(
            (responseCalculate?.delivery_price ?? 0) +
            (responseCalculate?.courier_price ?? 0)
          ).toFixed(2)} AZN`}
          translationData={data}
        />

        <PaymentStatusModal
          isOpen={isPaymentStatusOpen}
          isSuccess={paymentSuccess}
          onClose={() => setIsPaymentStatusOpen(false)}
          onRedirect={handlePaymentRedirect}
          errorMessage={paymentErrorMessage}
          translationData={data}
        />

        <NoCardsModal
          isOpen={isNoCardsModalOpen}
          onClose={() => setIsNoCardsModalOpen(false)}
          translationData={data}
        />
      </div>
    </>
  );
};

export default Courier;
